import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component({})
export default class StepsCounter extends Vue {

  @Prop({ default: ()=>[] }) steps;
  @Prop({ default: 0 }) currentStep;

  allSteps = [];

  get getPercentage() {
    let response = 0;
    if(this.currentStep === 1) {
      response = 0;
    } else if (this.currentStep === this.allSteps.length) {
      response = 100;
    } else {
      const piece = 100 / (this.allSteps.length - 1);
      response = piece * (this.currentStep - 1);
    }
    return response;
  }

  mounted() {
    this.onStepsChange();
  }

  @Watch('steps')
  onStepsChange() {
    let response = [...this.steps];
    const orderFunction = (a, b) => {
      return a.value - b.value;
    }
    if(this.steps && this.steps.length) {
      response = response.sort(orderFunction);
    }
    this.allSteps = [...response];
  }

  isStepActive(stepValue) {
    let response = false;
    if(this.currentStep >= stepValue) {
      response = true;
    }
    return response;
  }

  _setStep(value) {
    
    if(value < this.currentStep) {
      this.$emit('set-step', value);
    }
    
  }
}